import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-common-forge.personal-settings-section.heading',
		defaultMessage: 'Apps',
		description: 'Navigation section title for forge apps items',
	},
});
